import DtoFilter from '../dashboard/dto/DtoFilter'
import { find } from 'lodash'
import ResearchTypes from './ResearchTypes'

const createDto = (value, tipeId, filterParameter) => {
	return new DtoFilter({ value: value, filtertype_id: tipeId, filterParameter: filterParameter.type })
}

const getFilterTypeReference = (listOfFilterTypeReference, type) => {
	return find(listOfFilterTypeReference, (o) => {
		return o.filter == type
	})
}
const createDtoFilter = (listOfFilterTypeReference, filterResearch) => {
	if (filterResearch.type && filterResearch.type.type) {
		const filterReference = getFilterTypeReference(listOfFilterTypeReference, filterResearch.type.type)
		switch (filterReference.filter) {
			case ResearchTypes.CITY.type:
				return createDto(filterResearch.value.code, filterReference.id, ResearchTypes.CITY)
			case ResearchTypes.RADIUS.type:
				return createDto(filterResearch.value, filterReference.id, ResearchTypes.RADIUS)
			case ResearchTypes.STATION.type:
				return createDto(filterResearch.value.id, filterReference.id, ResearchTypes.STATION)
			case ResearchTypes.WATERSHED.type:
				return createDto(filterResearch.value.id || filterResearch.value.code, filterReference.id, ResearchTypes.WATERSHED)
			case ResearchTypes.MANAGEMENT_WATER.type:
				return createDto(filterResearch.value.id, filterReference.id, ResearchTypes.MANAGEMENT_WATER)
			case ResearchTypes.DEPARTMENT.type:
				return createDto(filterResearch.value.code, filterReference.id, ResearchTypes.DEPARTMENT)
			default:
				return null
		}
	}
	return null
}
const createDtoFilterTheme = (listOfFilterTypeReference, filterResearch) => {
	const filterReference = getFilterTypeReference(listOfFilterTypeReference, ResearchTypes.THEME.type)
	return createDto(filterResearch.value.id, filterReference.id, ResearchTypes.THEME)
}

const getFilterTypeConstant = (parameter) => {
	switch (parameter) {
		case ResearchTypes.RADIUS.type :
			return ResearchTypes.RADIUS
		case ResearchTypes.CITY.type :
			return ResearchTypes.CITY
		case ResearchTypes.WATERSHED.type :
			return ResearchTypes.WATERSHED
		case ResearchTypes.STATION.type :
			return ResearchTypes.STATION
		case ResearchTypes.MANAGEMENT_WATER.type :
			return ResearchTypes.MANAGEMENT_WATER
		case ResearchTypes.DEPARTMENT.type :
			return ResearchTypes.DEPARTMENT
		default:
			return null
	}
}

const getRgb = (rgb) => {
	return 'rgb(' + rgb + ')'
}
const getRgba = (rgb, opacity = 0.7) => {
	return 'rgba(' + rgb + ',' + opacity + ')'
}

const getColorRgb = (type, rgba = false, opacity = '0.15') => {
	return rgba ? getRgba(type.color, opacity) : getRgb(type.color)
}
export { createDto, getFilterTypeReference, createDtoFilter, createDtoFilterTheme, getFilterTypeConstant, getColorRgb, getRgb, getRgba }



// WEBPACK FOOTER //
// ./src/utils/ResearchTypesUtils.js